//请自行添加语言资源
const supplierContractDetail = {
  contractTypeName:'类型',
  goodsCategoryName:'干/潮',
  supplierName:'供应商',
  grainAddressDetail:'区域',
  vehicleInPlantTime:'实际进厂时间',
  vehicleOutPlantTime:'实际出厂时间',
  contractNo:'合同号',
  qcNo:'取样单号',
  vehicleNo:'车牌号',
  unpeelWeight:'毛重',
  peelWeight:'皮重',
  netWeight:'净重',
};
export default supplierContractDetail



// WEBPACK FOOTER //
// ./src/page/report/supplierContractDetail/lang/supplierContractDetail.zh.js